import { Text, View } from 'react-native'
import { Bell, CalendarCheck, CalendarClock, Clock } from 'lucide-react-native'
import type { ComponentType } from 'react'
import type { LucideProps } from 'lucide-react-native'
import { useTranslation } from 'react-i18next'
import { colors } from '@chillout/core'

interface InfoItemProps {
  Icon: ComponentType<LucideProps>
  titleKey: string
  bodyKey: string
}

function InfoItem({ Icon, titleKey, bodyKey }: InfoItemProps) {
  const { t } = useTranslation()

  return (
    <View className="w-full lg:w-[calc(50%_-_8px)] flex-row items-start gap-3">
      <View className="h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent/10">
        <Icon size={16} color={colors.accent.DEFAULT} strokeWidth={2} />
      </View>
      <View className="flex-1 gap-0.5">
        <Text className="text-sm font-semibold text-primary">{t(titleKey)}</Text>
        <Text className="text-sm text-secondary">{t(bodyKey)}</Text>
      </View>
    </View>
  )
}

interface BirthdayRewardHowItWorksSectionProps {
  stepNumber: number
}

export function BirthdayRewardHowItWorksSection({ stepNumber }: BirthdayRewardHowItWorksSectionProps) {
  const { t } = useTranslation()

  return (
    <View className="gap-5 rounded-xl border border-border bg-canvas-card p-6">
      <View className="flex-row items-baseline gap-2">
        <Text className="text-lg font-semibold text-primary">{stepNumber}.</Text>
        <Text className="text-lg font-semibold text-primary">{t('birthdayReward.howItWorks.sectionTitle')}</Text>
      </View>

      <View className="flex-row flex-wrap gap-4">
        <InfoItem
          Icon={CalendarCheck}
          titleKey="birthdayReward.howItWorks.birthdaySaved.title"
          bodyKey="birthdayReward.howItWorks.birthdaySaved.body"
        />
        <InfoItem
          Icon={CalendarClock}
          titleKey="birthdayReward.howItWorks.oncePerYear.title"
          bodyKey="birthdayReward.howItWorks.oncePerYear.body"
        />
        <InfoItem
          Icon={Bell}
          titleKey="birthdayReward.howItWorks.notification.title"
          bodyKey="birthdayReward.howItWorks.notification.body"
        />
        <InfoItem
          Icon={Clock}
          titleKey="birthdayReward.howItWorks.validMonth.title"
          bodyKey="birthdayReward.howItWorks.validMonth.body"
        />
      </View>
    </View>
  )
}
